export default class CampCardTags extends React.Component {
  constructor(props) {
    super(props);
  }

  ratingBlock() {
    if (!(this.props.rating > 0)) return null;
    const rating = this.props.rating.toFixed(1);
    return (
      <a className="card__rating">
        <div
          className={`card__rating-numb ${rating < 8 && "card__rating-numb-gray"}`}
        >
          <span className="card__rating-numb-big">{rating}</span>
          <span className="card__rating-numb-small">&nbsp;/ 10</span>
        </div>
      </a>
    );
  }

  isRecommended() {
    if (!this.props.is_recommended) return null;
    return (
      <div
        className={`like ${this.props.rating <= 0 && "like-without-rating"}`}
      >
        <div className="like-img"></div>
        Рекомендуем
      </div>
    );
  }

  ratingsCount() {
    if (!this.props.ratings_count_string || !(this.props.rating > 0))
      return null;
    return (
      <div className={"ratings-count"}>{this.props.ratings_count_string}</div>
    );
  }

  render() {
    const { is_recommended: isRecommended, hideRatingsCount } = this.props;
    return (
      <div className="sanatoriums_card__tags">
        {this.ratingBlock()}
        {this.isRecommended()}
        {(!isRecommended || !hideRatingsCount) && this.ratingsCount()}
      </div>
    );
  }
}
